import Select from "react-select";

const MultiSelectAutocomplete = ({ options, setSelectedOptions }) => {
  const handleChange = (selected) => {
    setSelectedOptions(selected);
  };
  
  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? '#01A532' : base.borderColor,
      boxShadow: state.isFocused ? '0 0 0 1px #01A532' : 'none',
      '&:hover': {
        borderColor: '#01A532',
      },
    }),
    option: (base, state) => ({
      ...base,
      borderRadius: state.isSelected ? "20px" : "3px",
      backgroundColor: state.isSelected ? "#01A532" : "#ffffff",
      color: state.isSelected ? "#ffffff" : "#000000",
      "&:hover": {
        backgroundColor: state.isSelected ? '#01A532' : '#E8F5E8',
        color: state.isSelected ? 'white' : 'black',
      },
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: '#01A532',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: 'white',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: 'white',
      '&:hover': {
        backgroundColor: '#007A28',
        color: 'white',
      },
    }),
  };

  return (
    <Select
      required
      isMulti
      options={options}
      placeholder=""
      styles={customStyles}
      onChange={handleChange}
    />
  );
};

export default MultiSelectAutocomplete;
